<template>
  <div>
    <Breadcrumb :title="'Correction Log'"></Breadcrumb>

    <div class="form-row">
      <BaseSearchBar :config="search" @keyupSearch="filterGrid"></BaseSearchBar>
      
    </div>
    <div class="btnDiv">
      <BaseToolBar  :config="toolBarConfig" @buttonClicked="toolbarOnClick"></BaseToolBar>
    </div>
    <div>
      <BaseGrid
        :config="gridConfig"
        :excelExport="excelExport"
        :data="CorrectionHistory"
      ></BaseGrid>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import {
  CorrectionLogToolbarConfig,
  IssuanceCorrectionLogConfig,
  TransferCorrectionLogConfig,
  VestingCorrectionLogConfig
} from "./CorrectionLogConfig.js";

import Breadcrumb from "@/components/layout/Breadcrumb.vue";
import BaseGrid from "@/components/base/BaseGrid.vue";
import apiUtil from "@/services/apiUtil.js";
import funcUtil from "@/services/funcUtil.js";
import BaseSearchBar from "@/components/base/BaseSearchBar.vue";
import BaseToolBar from "@/components/base/BaseToolbar.vue";
import toolbarUtility from "@/services/toolbarUtility.js";
//import CorrectionForm from "@/components/forms/CorrectionForm.vue";
//import BaseModelUnitClass from "@/models/BaseModelUnitClass.js";
//import BaseModelDocument from "@/models/BaseModelDocument.js";
import BaseModelCorrectionLog from "@/models/BaseModelCorrectionLog.js";
import { mapGetters, mapActions, mapState } from 'vuex';
import _ from 'lodash';
import { isNullOrUndefined } from 'util';

//import CorrectionDocumentDropoffForm from "@/components/forms/CorrectionDocumentDropoffForm.vue";

export default {
  name: "CorrectionEvent",
  mixins: [apiUtil, funcUtil, toolbarUtility],
  computed:{
    ...mapGetters("getModule", [
      "withFilter",
      "getAllItemFilter",
      "GetValueByKey"
    ]),
    gridConfig(){
      switch (this.selectedBusinessEvent) {
        case "Issuance":
          return IssuanceCorrectionLogConfig
          break;
        case "Transfer":
          return TransferCorrectionLogConfig
          break;
        case "Vesting":
          return VestingCorrectionLogConfig
          break; 
        default:
          return IssuanceCorrectionLogConfig
          break;
      }
    }
  },
  components: {
    Breadcrumb,
    BaseGrid,
    BaseSearchBar,
    BaseToolBar
  },
  data: function() {
    return {
      //gridConfig: CorrectionEventGridConfig,
      search: {
        SearchData: ""
      },
      CorrectionLogGridId: "CorrectionLogGrid",
      CorrectionLogMasterData: {},
      toolBarConfig:CorrectionLogToolbarConfig,
      BaseModelCorrectionLog: BaseModelCorrectionLog,
      //BaseModelUnitClass: BaseModelUnitClass,
      selectedBusinessEvent:"Issuance",
      CorrectionID:null,
      CorrectionHistory:[]
    };
  },
  methods: {
    ...mapActions("getModule",["AddCollection"]),

    UpdateCorrectionMasterData: function(fromFilter, filterMasterData) {
      if (fromFilter == true) {
        this.CorrectionLogMasterData = filterMasterData;
      } else {
        this.CorrectionLogMasterData = JSON.parse(
          JSON.stringify(
            $("#CorrectionLogGrid")
              .data()
              .kendoGrid.dataSource.data()
          )
        );
      }
    },
    toolbarOnClick: function(e) {
      e.preventDefault();
      switch (e.id) {
        case "btnBackToCorrectionReport":
          this.AddCollection({ key: "CorrectionBusinessEvent", value: this.selectedBusinessEvent });
          //this.$router.go(-1)
          this.$router.push("/report/correction");
          break;
      
        default:
          break;
      }
      this._baseToolBarEvents("CorrectionLogGrid", ...arguments);
    },

    filterGrid: function() {
      let self = this;

      let currentMasterdata = this.CorrectionLogMasterData;

      let filteredData = this._filterGrid(
        this.CorrectionLogMasterData,
        this.search.SearchData
      );
      $("#CorrectionLogGrid").data("kendoGrid").dataSource.data(filteredData);
      this.UpdateCorrectionMasterData(true, currentMasterdata);
    },
    async getCorrectionLogHistory() {
      const self = this;
      self.CorrectionID = self.GetValueByKey("CorrectionID")
      self.selectedBusinessEvent = self.GetValueByKey("BusinessEvent")
      await self.getCorrectionLogHistoryByID();
      self._loadGridSettings(self.CorrectionLogGridId);
    },
    getCorrectionLogHistoryByID(){
      let query={
        filter: "BusinessEvent eq "+ "'"+ this.selectedBusinessEvent + "'" +` and CorrectionID eq ${this.CorrectionID}`,
        limit: 5000
        };
        console.log(query)
      let response = this.withFilter(this.BaseModelCorrectionLog.list,query);
      this.CorrectionHistory=((response && response.length>0))?response:[]
    }
  },
  mounted() {
    let self = this;

    self.getCorrectionLogHistory();

    //bind databound event to grid
    let grid = $("#CorrectionLogGrid").data("kendoGrid");
    grid.bind("dataBound", self.UpdateCorrectionMasterData);
    grid.dataSource.fetch();
  },
};
</script>
<style>

</style>


